const state = () => ({
  dark_theme:true,
})
const mutations = {
  SWITCH_THEME (state) {
    state.dark_theme = !state.dark_theme
  },
}
const actions = {
  setTheme({ commit }){
    commit('SWITCH_THEME')
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
